import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly document = inject(DOCUMENT);
  private readonly storageKey = 'gm-theme';
  private readonly darkModeSignal = signal<boolean>(false);

  readonly darkMode = this.darkModeSignal.asReadonly();

  constructor() {
    this.initializeTheme();
  }

  setDarkMode(enabled: boolean): void {
    this.darkModeSignal.set(enabled);
    this.document.body.classList.toggle('dark-mode', enabled);
    localStorage.setItem(this.storageKey, enabled ? 'dark' : 'light');
  }

  toggleDarkMode(): void {
    this.setDarkMode(!this.darkModeSignal());
  }

  private initializeTheme(): void {
    const storedTheme = localStorage.getItem(this.storageKey);

    if (storedTheme === 'dark') {
      this.setDarkMode(true);
      return;
    }

    if (storedTheme === 'light') {
      this.setDarkMode(false);
      return;
    }

    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.setDarkMode(prefersDark);
  }
}
